import React from 'react';
import { observer } from 'mobx-react';
import ExcelTableTds from './TableTds';
import Actions from '../../stores/card/actions';
import CardStore  from '../../stores/card';
import { getRowIndex } from '../../util/typeUtil';
import ModeExcel from '../../stores/card/ModeExcel';
import CubeForm from '../../stores/form/form';
import { WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
export interface ExcelTableTBodyProps {
    form: CubeForm;
    actions: Actions;
    card: CardStore;
    detail?: string;
    excel: ModeExcel;
}

@observer
export default class ExcelTableTBody extends React.Component<ExcelTableTBodyProps, any> {

    renderDetailTrs = (): JSX.Element[][] => {
        const { excel, form, card, detail } = this.props;
        const { edtitleinrow = '0', edtailinrow = '0', seniorset = '0' } = excel || {};
        let headRow = parseInt(edtitleinrow, 0);
        let bodyRow = parseInt(edtailinrow, 0);
        let isSeniorset = seniorset == '1';
        let _rowhead = excel.rows.slice();
        if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
            return ([[<div>{getLabel(386148, '对不起，表头标识、表尾标识设置异常，无法渲染明细！')}</div>]])
        }
        let detailLenth = 0;
        
        return excel ? _rowhead.map((row) => {
            const rowIndex: number = getRowIndex(row.id);
            let trs: JSX.Element[] = [];
            if (rowIndex == headRow + 1) {
                //位于表头表尾标识之间
                for (let j = 0; j < detailLenth; j++) {
                    for (let i = rowIndex; i < bodyRow; i++) {
                        let style_obj ={}
                        if(row.obj && row.obj['style']){
                            style_obj = this.getTrStyle(row.obj['style'])
                        }
                        trs.push(<tr style={{ height: row.size,...style_obj }}>
                            <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@5w91ug@${j}`} excel={excel} detailIndex={j} row={getRowIndex(row.id)} card={card} form={form}  detail={detail} isFixFieldDiv={false}  isTitle={false}/>
                        </tr>)
                    }
                }
                return trs;
            } else if (rowIndex < headRow || (isSeniorset && rowIndex > bodyRow)) {
                let style_obj ={}
                if(row.obj && row.obj['style']){
                    style_obj = this.getTrStyle(row.obj['style'])
                }
                trs.push(<tr style={{ height: row.size,...style_obj }}>
                    <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@7olifg@${row.id}`} excel={excel} row={getRowIndex(row.id)} card={card} form={form} detail={detail} isFixFieldDiv={false}  isTitle={true}/>
                </tr>)
            }
            return trs
        }) : [];
    }
    renderMainTrs = (): JSX.Element[] => {
        const { excel, form, card, detail } = this.props;
        let rowhead = excel ? excel.rows.slice() : [];
        return excel ? rowhead.map((row) => {
            let style_obj = {};
            if(row.obj && row.obj['style']){
                style_obj = this.getTrStyle(row.obj['style'])
                delete row.obj['style']
            }
            return (
                <tr style={{ height: row.size,display: row.obj.hide && row.obj.hide=="y" ? "none":"table-row",...style_obj}} {...row.obj}>
                    <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@jrfr1k@${row.id}`} row={getRowIndex(row.id)} excel={excel} card={card} form={form}  detail={detail} isFixFieldDiv={false}  isTitle={false}/>
                </tr>
            )
        }) : [];
    }

    getTrStyle = (styleStr) => {
        let styleArr = styleStr.split(';');
        let styleObj:any = {};
        styleArr.forEach(item => {
            if(item.indexOf(':')>-1){
                let [ key,value ]= item.split(':');
                if(key){
                    styleObj[key] = value || ''
                }
            }
        });
        return styleObj;
    }

    renderFloatImg  = (): JSX.Element[] => {
        const { excel } = this.props;
        let trs: JSX.Element[] = [];
        const floatImgArr = excel.floatingObjectArray && excel.floatingObjectArray.floatingObjects;
        let imgArr = new Array();
        if(!!floatImgArr){
            floatImgArr.map(imgInfo=>{
                const imgStyle = {width:imgInfo.width,height:imgInfo.height,top:imgInfo.y,left:imgInfo.x,position:'absolute',zIndex:'999'}
                imgArr.push(React.createElement("img",{src:imgInfo.src,style:imgStyle}));    
            });
            const columnSize = Object.keys(excel.cols).length;
            trs.push(React.createElement("tr",{style:{height:"0px"}},[
                React.createElement("td",{colSpan:columnSize},imgArr)
            ]));
        }
        return trs
    } 
    render() {
        const { detail } = this.props;
        return (
            <tbody>
                {detail ? this.renderDetailTrs() : this.renderMainTrs()}
                {this.renderFloatImg()}
            </tbody>
        )
    }
} 


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/TableTBody.tsx